<template>
  <v-menu
    v-model="menu1"
    :close-on-content-click="false"
    :nudge-right="40"
    offset-y
    class="imd-sm-input-date-picker  no-transition"
    min-width="293px">
    <template v-slot:activator="{ on }">
      <v-text-field
        :value="value_dp"
        v-bind="$attrs"
        v-on="{...on, ...$listeners, input: onEditText}"

        label=""
        append-icon="event"
        class="imd-sm-input-date imd-sm-input"
        outlined
      ></v-text-field>
    </template>
    <v-date-picker
      no-title
      :value="calcPickerDate"
      @input="onDatePicker"
      :day-format="date => parseInt(date.split('-')[2])"
      locale="ko-kr" />
  </v-menu>
</template>

<script>
  export default {
    created () {
      this.init()
    },
    watch: {
      value() {
        this.init()
      }
    },
    props: {
      value  : String,
      value_format: {
        type: String,
        default: 'YYYY-MM-DD'
      },
      dp_format : {
        type: String,
        default: 'YYYY-MM-DD'
      }
    },
    data () {
      return {
        value_cp : null, // 실제 데이터 : value_format 형식 미지정시 YYYY-MM-DD. 하지만 보여주는 것은 dp_format 형식
        value_dp : null, // 보여주기 가상 데이터
        menu1: false
      }
    },
    computed: {
      calcPickerDate() {
        if (!this.value_cp) return "";
        return this.$moment(this.value_cp, this.value_format).format('YYYY-MM-DD')
      }
    },

    methods: {
      init() {
        this.value_cp = this.value
        if (this.value_cp)
          this.value_dp = this.$moment(this.value_cp, this.value_format).format(this.dp_format)
      },
      onEditText(e) {
        this.value_dp = e
        let v = null
        try {
          v = this.$moment(this.value_dp, this.dp_format).format(this.value_format)
          if (v == "Invalid date") {
            return
          }
          this.value_cp = v
          this.$emit('input', v)
        } catch(e) {
          console.log("오류", e)
        }
      },
      onDatePicker(e) {
        this.menu1 = false;
        const v = this.$moment(e, 'YYYY-MM-DD').format(this.value_format)
        this.value_cp = v
        this.$emit('input', v)
        this.value_dp = this.$moment(this.value_cp, this.value_format).format(this.dp_format)
      },
    },
  }

</script>
